<template>
	<nk-dropdown v-model="dropdownValue" :data="dropdownData" :options="settings.dropdownOptions" :disabled="disabled ? true : null" ref="input" :tabindex="tabindex"></nk-dropdown>
</template>
<script>
	import _ from 'lodash'
	import { mapActions, mapGetters } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'
	import productGroup from '~/views/sale/products/product-group-list.vue'

	export default {
		props: {
			modelValue: {},
			options: {},
			disabled: { type: Boolean, default: false },
			tabindex: {}
		},
		emits: ['update:modelValue'],
		data() {
			return {
				settings: {
					hideParents: false,
					type: null,
					dropdownOptions: {
						rowIdentifier: 'id',
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						searchableFields: ['name'],
						findExactMatch: this.findExactMatch,
						selectorWidth: 'auto',
						buttons: [{
							title: this.$t('manage-items'),
							shortcut: $sc.find('enter'),
							isPrimary: true,
							element: () => { return this.$el },
							icon: 'list-ul',
							handle: (button, page, e) => {
								this.showProductGroups()
							}
						}]
					}
				},
				localValue: null
			}
		},
		computed: {
			...mapGetters({
				all: 'productGroups/all'
			}),
			dropdownValue: {
				get() {
					return this.localValue
				},
				set(val) {
					this.$emit('update:modelValue', val)
					this.localValue = val
				}
			},
			dropdownData() {
				let groups = []
				if (this.settings.hideParents) {
					for (let i = 0; i < this.all.length; i++) {
						if (!this.all[i].treeHasChild) {
							groups.push(this.all[i])
						}
					}
					return groups
				} else {
					return this.all
				}
			}
		},
		watch: {
			modelValue: {
				handler(val, oldVal) {
					this.localValue = val
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.extend({}, this.settings, val)
				}
			}
		},
		created() {
			this.localValue = this.modelValue
		},
		mounted() {
			this.refreshProductGroups()
		},
		methods: {
			...mapActions({
				refreshProductGroups: 'productGroups/refresh'
			}),
			showProductGroups() {
				this.showModal({ component: productGroup, data: null, options: { type: this.settings.type, selectable: true } })
					.then(result => {
						this.dropdownValue = result
						this.$refs.input.focusAndSelect()
					}).catch(() => { })
			}
		},
	}
</script>
<style></style>
